import { Component } from '@opten/compiler/metadata/component';
import { debounce } from '@opten/reactive/debounce';

declare const Swiper: any;

@Component({ className: 'js-media-slider' })
export class MediaSliderComponent {
	constructor(private element: HTMLElement) {
		const autoplay = parseInt(this.element.getAttribute('data-autoplay'), 0) || 0;
		const swiper = new Swiper(element, {
			autoHeight: true,
			speed: 1000,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			parallax: true,
			autoplay: (autoplay > 0 ? {
				delay: autoplay,
			  } : false),
		});

		document.addEventListener('lazyloaded', (e) => {
			swiper.updateAutoHeight(0);
		});

		window.addEventListener(
			'resize',
			debounce(() => {
				swiper.updateAutoHeight(0);
			}, 400)
		);
	}
}
